import { gql } from "@apollo/client";

export const QUERY_ONBOARDING = gql`
  query onBoarding {
    onBoardingPage {
      logo {
        url
        alternativeText
      }
      steps {
        title
        description
        image {
          url
          alternativeText
        }
        button {
          text
          link
        }
      }
    }
  }
`;
